// @ts-check
/**
 *
 * @param {EntityId} blockId
 * @param {Channel_Type} channel
 * @param {string} name
 */
export function generateId(blockId, channel, name) {
    return `${blockId}.${channel}.${name}`
}

/**
 *
 * @param {Broadcastable} broadcast
 */
export function validateBroadcast(broadcast) {
    if (process.env.NODE_ENV === "production") return
    const isValid =
        broadcast.id &&
        broadcast.channel &&
        broadcast.name &&
        broadcast.published_name &&
        broadcast.ownerBlockId

    if (!isValid) {
        console.warn("broadcast is invalid")
        console.table(broadcast)
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/broadcast/utils.js